export const niceForm = {
  m: 'checkplusSerivce',
  encodeData: 'encodeDatavsl',
  callType: ''
}
